/* ML-01 · MULTI SETUP JOURNEY
   The nine-step multi-location setup, condensed: what is done, what is next. */
import { ListRow, Pill } from '@/ui'
import { useML } from './EtabShell'

export default function ML01Configurer() {
  const steps = useML().setup
  return (
    <section data-frame="ML-01" style={{ display: 'grid', gap: 14 }}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 16, flexWrap: 'wrap' }}>
        <h2 className="t-section" style={{ flex: 1 }}>Configurer plusieurs établissements</h2>
        {/* the wireframe’s abbreviated 1 › 2 › 3 › … › 9 indicator; @/ui’s Steps
            cannot elide, so the system’s own .steps classes are used directly */}
        <span className="steps">
          <span className="on">1</span><i> › </i>2<i> › </i>3<i> › </i>…<i> › </i>9
        </span>
      </div>
      <div>
        {steps.map(s => (
          <ListRow key={s.n}
            title={s.strong.map((t, i) => (
              <span key={t}>{i > 0 && ' · '}<strong>{i === 0 ? `${s.n} · ${t}` : t}</strong></span>
            ))}
            meta={s.meta}
            end={s.mark ? <Pill tone={s.mark.tone} mark={s.mark.mark}>{s.mark.label}</Pill> : undefined} />
        ))}
      </div>
    </section>
  )
}
